import { Fragment } from 'react';
import { noop } from 'shell/utils/noop';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { DocumentSerieVisualizeCrumbs } from 'civil-status/constants/document-serie-breadcrumb';
import FormDocumentSerie, { DocumentSerieForm } from 'civil-status/components/document-serie/form';
import { useNavigate, useParams } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { transformResponseDocumentSerie } from 'civil-status/utils/transformer-document-serie';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { DocumentSerie } from 'shell/models/document-serie';
import { HttpResponse } from 'shell/models/http-response';

const DocumentSerieDetailPage = (): React.ReactElement => {
  const navigate = useNavigate();
  const params = useParams();

  const [serie] = useHttpFetch<HttpResponse<DocumentSerie>, DocumentSerieForm>(
    `${__CIVIL_STATUS_API_URL__}/serie-atto/${params.id}`,
    {
      onBootstrap: true,
      transformer: transformResponseDocumentSerie,
    }
  );

  const serieData = serie.data as DocumentSerieForm;

  const isLoading = serie.isLoading || serie.pristine || serie.hasErrors;
  return (
    <Fragment>
      <Breadcrumbs items={DocumentSerieVisualizeCrumbs} />
      {!isLoading ? (
        <FormDocumentSerie
          title={'Dettaglio Serie'}
          onOk={noop}
          onCancel={() => {
            navigate('/stato-civile/serie');
          }}
          disabled
          initialValues={serieData}
        ></FormDocumentSerie>
      ) : undefined}
    </Fragment>
  );
};

DocumentSerieDetailPage.displayName = 'Document Serie Detail page component';

export default DocumentSerieDetailPage;
